/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const lnsuperRouter = {
	path: '/superstore',
	component: Layout,
	redirect: 'superstore',
	name: '商超',
	id: 1300000,
	meta: {
		title: '商超',
		icon: 'chart',
		roles: [1300000]
	},
	children: [
		{
			path: 'layout',
			component: LayoutView,
			name: '超市收银',
			id: 1310000,
			meta: {
				title: '超市收银',
				noCache: true,
				roles: [1310000]
			},
			redirect: 'superList',
			children: [
				{
					path: 'superList',
					component: () =>
						import(/* webpackChunkName: "role" */ '@/leniuview/superstore/index'),
					name: '超市管理',
					id: 1311000,
					meta: { title: 'lnbasesetting.superstore', noCache: true, roles: [1311000] }
				},
				// {
				//   path: 'shopList',
				//   component: () =>
				//     import ( /* webpackChunkName: "role" */ '@/leniuview/basesetting/superstore/shop'),
				//   name: '商城管理',
				//   id: 13110000,
				//   meta: { title: '商城管理', noCache: true, roles: [13110000] },
				// },
				{
					path: 'superDetail',
					component: () =>
						import(/* webpackChunkName: "role" */ '@/leniuview/superstore/shopDetail'),
					name: '超市商品',
					id: 1311000,
					meta: { title: '超市商品', noCache: true, roles: [1311000] },
					hidden: true
				},
				{
					path: 'shopYuanliao',
					component: () =>
						import(/* webpackChunkName: "role" */ '@/leniuview/superstore/shopYuanliao'),
					name: '商品',
					id: 1312000,
					meta: { title: '商品', noCache: true, roles: [1312000] }
				},
				{
					path: 'superUitId',
					component: () =>
						import(/* webpackChunkName: "role" */ '@/leniuview/superstore/superUitId'),
					name: '单位',
					id: 1313000,
					meta: { title: '单位', noCache: true, roles: [1313000] }
				}
			]
		},
		{
			path: '',
			component: LayoutView,
			name: '超市订单',
			id: 1320000,
			meta: {
				title: '超市订单',
				noCache: true,
				roles: [1320000]
			},
			redirect: 'superOrderDetail',
			children: [{
				path: 'superOrderDetail',
				component: () =>
					import(
						/* webpackChunkName: "AIcheng" */
						'@/leniuview/superstore/superOrder/orderDetail'
					),
				name: '订单明细',
				id: 1321000,
				meta: {
					title: '订单明细',
					roles: [1321000]
				}
			}, {
				path: 'superOrderDetailYd',
				component: () =>
					import(
						/* webpackChunkName: "AIcheng" */
						'@/leniuview/superstore/superOrder/yudingOrderDetail'
					),
				name: '预订单明细',
				id: 1322000,
				meta: {
					title: '预订单明细',
					roles: [1322000]
				}
			}, {
				path: 'superShopTj',
				component: () =>
					import(
						/* webpackChunkName: "AIcheng" */
						'@/leniuview/superstore/superOrder/superShopTj'
					),
				name: '商品统计汇总',
				id: 1323000,
				meta: {
					title: '商品统计汇总',
					roles: [1323000]
				}
			}, {
				path: 'superShopOrderTj',
				component: () =>
					import(
						/* webpackChunkName: "AIcheng" */
						'@/leniuview/superstore/superOrder/superShopOrderTj'
					),
				name: '下单人数统计',
				id: 1324000,
				meta: {
					title: '下单人数统计',
					roles: [1324000]
				}
			}, {
				path: 'orderStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/superstore/superOrder/orderStatistics'),
				name: '订单统计',
				id: 1325000,
				meta: { title: '订单统计', roles: [1325000] }
			}, {
				path: 'courierDishStatisticscommon',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/superstore/superOrder/courierDishStatisticscommon'),
				name: '配送明细',
				id: 1326000,
				meta: { title: '配送明细', roles: [1326000] }
			}, {
				path: 'orderShenhe',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/superstore/superOrder/orderShenhe'),
				name: '退款审核',
				id: 1327000,
				meta: { title: '退款审核', roles: [1327000] }
			}]
		},

		//
		{
			path: '',
			component: LayoutView,
			name: '超市设备',
			id: 1330000,
			meta: {
				title: '超市设备',
				noCache: true,
				roles: [1330000]
			},
			redirect: 'DIYshouyinji',
			children: [{
				path: 'DIYshouyinji',
				component: () =>
					import(
						/* webpackChunkName: "AIcheng" */
						'@/leniuview/superstore/supermachine/DIYshouyinji'
					),
				name: '自助超市收银机',
				id: 1331000,
				meta: {
					title: '自助超市收银机',
					roles: [1331000]
				}
			}, {
				path: 'doubleshouyinji',
				component: () =>
					import(
						/* webpackChunkName: "AIcheng" */
						'@/leniuview/superstore/supermachine/doubleshouyinji'
					),
				name: '双屏超市收银机',
				id: 1332000,
				meta: {
					title: '双屏超市收银机',
					roles: [1332000]
				}
			}, {
				path: 'doubledayinji',
				component: () =>
					import(
						/* webpackChunkName: "AIcheng" */
						'@/leniuview/superstore/supermachine/doubledayinji'
					),
				name: '称重标签打印机',
				id: 1333000,
				meta: {
					title: '称重标签打印机',
					roles: [1333000]
				}
			}, {
				path: 'printMachine',
				component: () =>
					import(
						/* webpackChunkName: "AIcheng" */
						'@/leniuview/superstore/supermachine/dayinji'
					),
				name: '超市打印机',
				id: 1334000,
				meta: {
					title: '超市打印机',
					roles: [1334000]
				}
			}]
		}
		// {
		// 	path: '',
		// 	component: () =>
		// 		import(
		// 			/* webpackChunkName: "AIcheng" */
		// 			'@/leniuview/superstore/layout'
		// 		),
		// 	name: '营业收入报表',
		// 	id: 1340000,
		// 	meta: {
		// 		title: '营业收入报表',
		// 		noCache: true,
		// 		roles: [1340000]
		// 	},
		// 	redirect: 'supermarketIncome',
		// 	children: [{
		// 		path: 'supermarketIncome',
		// 		component: () =>
		// 			import(
		// 				/* webpackChunkName: "AIcheng" */
		// 				'@/leniuview/superstore/superreport/supermarketIncome'
		// 			),
		// 		name: '超市收入汇总',
		// 		id: 1341000,
		// 		meta: {
		// 			title: '超市收入汇总',
		// 			roles: [1341000]
		// 		}
		// 	}, {
		// 		path: 'supermarketDetail',
		// 		component: () =>
		// 			import(
		// 				/* webpackChunkName: "AIcheng" */
		// 				'@/leniuview/superstore/superreport/supermarketDetail'
		// 			),
		// 		name: '商品销售明细',
		// 		id: 1342000,
		// 		meta: {
		// 			title: '商品销售明细',
		// 			roles: [1342000]
		// 		}
		// 	}, {
		// 		path: 'supermarketZuzhi',
		// 		component: () =>
		// 			import(
		// 				/* webpackChunkName: "AIcheng" */
		// 				'@/leniuview/superstore/superreport/supermarketZuzhi'
		// 			),
		// 		name: '按组织收入汇总',
		// 		// 1344000
		// 		id: 1344000,
		// 		meta: {
		// 			title: '按组织收入汇总',
		// 			roles: [1344000]
		// 		}
		// 	}, {
		// 		path: 'supermarketMachine',
		// 		component: () =>
		// 			import(
		// 				/* webpackChunkName: "AIcheng" */
		// 				'@/leniuview/superstore/superreport/supermarketMachine'
		// 			),
		// 		name: '按设备收入汇总',
		// 		id: 1343000,
		// 		meta: {
		// 			title: '按设备收入汇总',
		// 			roles: [1343000]
		// 		}
		// 	}, {
		// 		path: 'supermarketPersonType',
		// 		component: () =>
		// 			import(
		// 				/* webpackChunkName: "AIcheng" */
		// 				'@/leniuview/superstore/superreport/supermarketPersonType'
		// 			),
		// 		name: '按人员类别收入汇总',
		// 		// 1345000
		// 		id: 1345000,
		// 		meta: {
		// 			title: '按人员类别收入汇总',
		// 			roles: [1345000]
		// 		}
		// 	}]
		// },
		// {
		// 	path: '',
		// 	component: () =>
		// 		import(
		// 			/* webpackChunkName: "AIcheng" */
		// 			'@/leniuview/superstore/layout'
		// 		),
		// 	name: '经营分析报表',
		// 	id: 1350000,
		// 	meta: {
		// 		title: '经营分析报表',
		// 		noCache: true,
		// 		roles: [1350000]
		// 	},
		// 	redirect: 'supermarketShopAnalysis',
		// 	children: [{
		// 		path: 'supermarketShopAnalysis',
		// 		component: () =>
		// 			import(
		// 				/* webpackChunkName: "AIcheng" */
		// 				'@/leniuview/superstore/superreport/supermarketShopAnalysis'
		// 			),
		// 		name: '商品销售排行',
		// 		id: 1351000,
		// 		meta: {
		// 			title: '商品销售排行',
		// 			roles: [1351000]
		// 		}
		// 	}, {
		// 		path: 'supermarketShopPrice',
		// 		component: () =>
		// 			import(
		// 				/* webpackChunkName: "AIcheng" */
		// 				'@/leniuview/superstore/superreport/supermarketShopPrice'
		// 			),
		// 		name: '商品价格浮动',
		// 		id: 1352000,
		// 		meta: {
		// 			title: '商品价格浮动',
		// 			roles: [1352000]
		// 		}
		// 	}]
		// }
	]
}

export default lnsuperRouter
